/**
 * AudioStatusBar — M2.2.4 · Controllo esplicito notifiche audio.
 *
 * Mostra 🔔 con stato chiaro:
 *   "attive"   → verde, click per disattivare
 *   "off"      → grigio, click per attivare
 *   "suspended"/pre-warm → arancione "Attiva le notifiche" (richiede click)
 *   "unsupported" → hidden
 */
import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { audioNotifications } from "@/lib/audioNotifications";

export function AudioStatusBar() {
  const [state, setState] = useState(audioNotifications.state);

  useEffect(() => audioNotifications.subscribe(setState), []);

  if (state === "unsupported") return null;

  let label, icon, cls, testid, onClick;
  if (state === "running") {
    label = "Notifiche attive";
    icon = <Bell className="w-4 h-4" strokeWidth={2} />;
    cls = "bg-green-50 border-green-300 text-green-800 hover:bg-green-100";
    testid = "audio-status-running";
    onClick = () => audioNotifications.disable();
  } else if (state === "off") {
    label = "Notifiche audio disattivate";
    icon = <BellOff className="w-4 h-4" strokeWidth={2} />;
    cls = "bg-sand-100 border-sand-300 text-ink-500 hover:bg-sand-200";
    testid = "audio-status-off";
    onClick = () => audioNotifications.enable();
  } else {
    // "suspended" — richiede click esplicito per unlock
    label = "Attiva notifiche messaggi";
    icon = <Bell className="w-4 h-4 animate-pulse" strokeWidth={2} />;
    cls = "bg-amber-50 border-amber-300 text-amber-800 hover:bg-amber-100";
    testid = "audio-status-suspended";
    onClick = () => audioNotifications.enable();
  }

  return (
    <button
      type="button"
      data-testid={testid}
      data-audio-state={state}
      onClick={onClick}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full
                    border-2 text-sm font-medium transition ${cls}`}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
